import { render, staticRenderFns } from "./ChecklistsView.vue?vue&type=template&id=ec5316c0"
import script from "./ChecklistsView.vue?vue&type=script&lang=ts"
export * from "./ChecklistsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports